import Section from 'components/Panel/Section';
import MultilineInput from 'components/Widget/Input/MultilineInput';
import { Style } from 'dragonmouse-shared/style';
import React from 'react';
import { useDispatch } from 'react-redux';
import { displayViewOnlyModal } from 'redux/mode/util';
import * as Panel from '../../../styles';

interface InstructionSetupProps {
	activeStyle: Style;
	updateCurrentStyle: (update: Partial<Style>) => void;
	viewOnly?: boolean;
}
const InstructionSetup = ({ activeStyle, updateCurrentStyle, viewOnly }: InstructionSetupProps) => {
	const dispatch = useDispatch();

	const onInstructionsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (viewOnly) {
			displayViewOnlyModal();
			return;
		}
		if (!activeStyle) return;
		updateCurrentStyle({ instructions: e.target.value });
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	return (
		<Section label="Instructions">
			<Panel.LittleSpacer />
			<MultilineInput
				value={activeStyle?.instructions || ''}
				onInput={onInstructionsChange}
				placeholder="Enter design system instructions..."
				minLines={4}
				renderBorder={false}
			/>
		</Section>
	);
};

export default InstructionSetup;
